"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUi = exports.UiProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * UiProvider manages cross-cutting UI state
 *
 * Manages organizational context that other providers depend on:
 * - Selected organization (drives data filtering)
 * - Selected cohort degree plan (for plan comparison/copying)
 */
const react_1 = require("react");
const UiContext = (0, react_1.createContext)(undefined);
/**
 * UiProvider component that manages UI state
 */
const UiProvider = ({ children }) => {
    const [uiState, setUiState] = (0, react_1.useState)({
        selectedOrganization: null,
        selectedCohortDegreePlan: null,
    });
    /**
     * Set the selected organization
     */
    const setSelectedOrganization = (0, react_1.useCallback)((org) => {
        setUiState((prev) => (Object.assign(Object.assign({}, prev), { selectedOrganization: org, 
            // Clear cohort plan when organization changes
            selectedCohortDegreePlan: null })));
    }, []);
    /**
     * Set the selected cohort degree plan
     */
    const setSelectedCohortDegreePlan = (0, react_1.useCallback)((plan) => {
        setUiState((prev) => (Object.assign(Object.assign({}, prev), { selectedCohortDegreePlan: plan })));
    }, []);
    const value = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, uiState), { setSelectedOrganization,
        setSelectedCohortDegreePlan })), [uiState, setSelectedOrganization, setSelectedCohortDegreePlan]);
    return (0, jsx_runtime_1.jsx)(UiContext.Provider, { value: value, children: children });
};
exports.UiProvider = UiProvider;
/**
 * Custom hook to access UI context
 */
const useUi = () => {
    const context = (0, react_1.useContext)(UiContext);
    if (!context) {
        throw new Error('useUi must be used within a UiProvider');
    }
    return context;
};
exports.useUi = useUi;
